import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {getLanguageFromLocal} from "./helpers/language.helper";

interface MyInitOptions {
    fallbackLng: string;
    detection: {
        order: string[];
        cache: string[];
    };
    interpolation: {
        escapeValue: boolean;
    };
}

const initOptions: MyInitOptions = {
    fallbackLng: getLanguageFromLocal(),
    detection: {
        order: ['querystring', 'cookie'],
        cache: ['cookie']
    },
    interpolation: {
        escapeValue: false
    }
};

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(initOptions);